// AEM SPA Editor Default Element Ids
export const ADDRESS_SEARCH_ID = 'address-search';
export const BROADBAND_PLANS_ID = 'broadband-plans';
